import { PropsWithChildren, ReactElement } from "react";
import styles from "./DocumentGridViewContainer.module.less";

export const DocumentGridViewContainer = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.gridViewContainer}>
			{children}
		</div>
	);
};
DocumentGridViewContainer.displayName = "DocumentGridViewContainer";